module.exports = __webpack_public_path__ + "img/pattern.e608cb5f.png";